// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/7f3aa2c17ee5e86320be.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"bbd5d60d38c82b60066d","138":"b2e13d3b9fb9f8aef4c2","139":"9571b68f8e04a0cf84df"}[chunkId] + ".chunk.js";
};